import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAlignHorizontalCenter';
/** Renders an SVG icon. */
const SvgAlignHorizontalCenter = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M26 25a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-9v-2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4V4a1 1 0 1 0-2 0v3h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v2H6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h9v3a1 1 0 1 0 2 0v-3zm0-6v4H6v-4zM21 9v4H11V9z"
        clipRule="evenodd"
      />
    </svg>
  );
};
SvgAlignHorizontalCenter.displayName = displayName;
export default SvgAlignHorizontalCenter;
